import { useTheme } from '@/hooks/use-theme'
import { ThemeEnum } from '@/hooks/use-theme/enum'

/**
 * 主题切换按钮组件
 * 支持亮色、暗色和跟随系统三种模式的循环切换
 */
export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()

  const getThemeLabel = () => {
    switch (theme) {
      case ThemeEnum.Light:
        return '亮色模式'
      case ThemeEnum.Dark:
        return '暗色模式'
      case ThemeEnum.System:
        return '跟随系统'
      default:
        return '未知'
    }
  }

  return (
    <button
      type='button'
      onClick={toggleTheme}
      className='inline-flex items-center justify-center rounded-md p-2 transition-colors duration-200 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none'
      title={`当前主题: ${getThemeLabel()}\n点击切换主题`}
      aria-label={`切换主题，当前: ${getThemeLabel()}`}
    >
      <span className='sr-only'>切换主题</span>
      {theme === ThemeEnum.Light && (
        <svg className='h-5 w-5 text-gray-800' fill='none' viewBox='0 0 24 24' stroke='currentColor' aria-hidden='true'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z'
          />
        </svg>
      )}
      {theme === ThemeEnum.Dark && (
        <svg className='h-5 w-5 text-gray-200' fill='none' viewBox='0 0 24 24' stroke='currentColor' aria-hidden='true'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z'
          />
        </svg>
      )}
      {theme === ThemeEnum.System && (
        <svg className='h-5 w-5 text-gray-800 dark:text-gray-200' fill='none' viewBox='0 0 24 24' stroke='currentColor' aria-hidden='true'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
          />
        </svg>
      )}
    </button>
  )
}
